module.exports = __webpack_public_path__ + "img/campany_logo.aa76cb37.png";